// Install the web bridge as `window.screenplay` BEFORE any renderer
// script imports run. main.js imports this module first so the static
// import graph evaluates this side-effect ahead of chart.js / app.js /
// the editor.

import { createBridge } from './bridge/index.js';

// Force the renderer's cloud-aware paths (cloud-create on New
// Project, "Move to cloud" affordance, migration banner) regardless
// of tier. The browser has no reliable local storage, so cloud is
// the only safe option for every signed-in web user — anon, free,
// or paid. Set before createBridge() / any renderer code reads it.
// On Electron this flag is never set, so the existing paid-only
// gates stay in effect there.
globalThis.__lastslate_force_cloud = true;

if (!globalThis.screenplay) {
  globalThis.screenplay = createBridge();
}
